export function init(slug?: string): void {
	import('./view')
		.then(mod => (new mod.ProjectDetailView({slug})));
}
